import React from 'react';

import { UndraggableImage } from 'components/shared/UndraggableImage';

interface Props {
  src: string;
}

export const ProductImage = React.memo(({ src }: Props) => {
  return (
    <UndraggableImage
      src={src}
      width={{ base: '80%', md: '35%', lg: '40%' }}
      m={{ base: 4, md: 8 }}
      mb={{ base: 8, md: 0 }}
    />
  );
});
